import { createSlice } from "@reduxjs/toolkit";

const selectedTemplateSlice = createSlice({
  name: "selectedTemplate",
  initialState: {
    selectedTemplate: null,
  },
  reducers: {
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
    clearSelectedTemplate: (state) => {
      state.selectedTemplate = null;
    },
  },
});

export const { setSelectedTemplate, clearSelectedTemplate } =
  selectedTemplateSlice.actions;
export default selectedTemplateSlice.reducer;
